/**
 * Root Provider Component
 *
 * MUI theme from design-system; adapter in design-system package.
 */

import { AviroLogin } from "@aviro360/login";
import { ClerkSessionTokenSync } from "design-components";
import { ThemeProvider, CssBaseline } from "design-system/mui";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./app";
import { theme } from "design-system/theme";
import { store } from "./app/shared/store/store";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? "";

const routerBasename =
  import.meta.env.BASE_URL === "/"
    ? undefined
    : import.meta.env.BASE_URL.replace(/\/$/, "");

export default function Root() {
  return (
    <AviroLogin publishableKey={clerkPublishableKey}>
      <ClerkSessionTokenSync>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <BrowserRouter basename={routerBasename}>
                <App />
              </BrowserRouter>
            </LocalizationProvider>
          </ThemeProvider>
        </Provider>
      </ClerkSessionTokenSync>
    </AviroLogin>
  );
}
